export default {
	route: {
		"home": "Home",
		"inquiry": "Inquiry Center",
		"allTitle": "Aggregated Price Inquiry",
		"expTitle": "International Express",
		"fbaTitle": "Dedicated First Leg",
		"airTitle": "International Air Freight",
		"seaTitle": "Ocean LCL"
	},
	navbar: {

	},
	home: {
		"titleone": "Get the best quote for you",
		"titletwo": "Start searching, comparing, booking, and managing your shipments!",
		"origin": "Origin",
		"originDesc": "Where are you shipping from?",
		"destination": "Destination",
		"destinationDesc": "Where are you shipping to?",
		"load": "Load",
		"loadDesc": "Where are you shipping?",
		"goods": "Goods",
		"goodsDesc": "Tell us about your goods",
		"addType": "Type",
		"addType_1": "Port/Aiport",
		"addType_2": "Factory/Warehouse",
		"addType_3": "Business address",
		"addType_4": "Residential address",
		"addType_5": "Private address",
		"addCountry": "Country",
		"Address": "Address",
		"AddPlhCode": "Enter port/airport code",
		"AddPlhZip": "Enter city/postal code",
		"checkNoList" : "Fill in your shipping information to start getting a price quote～",
		"checkHistory" : "Check price history",
		"checkEmpty" : "Clean",
		"goodsName": "Product Name",
		"goodsTip": "We do not accept any prohibited items containing liquids, powders, counterfeit labels, pastes, etc. If the declaration is false, once discovered, the system will fasten the fasteners and impose a maximum compensation of $2000.",
		"goodsMore": "Learn more",
		"goodsType": "Does your shipment contain any of the following goods?",
		"goodsValue": "Goods value",
		"goodsValueTip": "You can find your goods value on your commercial invoice.",
		"goodsReadyTime": "Are your goods ready?",
		"goodsReadyTimeTip": "Please pay attention to the validity period on each quotation. If your goods are not cleared through customs before that date, the tariff rate may change.",
		"goodsReadyTimeTip3" : "Please note that the tariff rate on the platform is updated every two weeks. If your goods are ready for customs entry only after the validity period (see each quotation), your tariff rate will be different from the rate selected at the time.",
		"goodsReady1": "Yes, my goods are ready",
		"goodsReady2": "Will be ready within two weeks",
		"goodsReady3": "Will be ready in more than two weeks",
		"eachItem": "Calculate by unit type",
		"eachTicket": "Calculate by total shipment",
	},
	common: {
		"confirm": "Confirm",
		"signin": "Sign In",
		"signup": "Sign Up",
		"piece": "Piece",
		"sea": "Sea",
		"air": "Air",
		"noData": "No data",
		"pleaseEnter": "Please enter",
		"pleaseSelect": "Select timeframe",
		"shipments": "Order",
		"billing": "Bill",
		"settings": "Settings",
		"logout": "Sign out",
	},
	login: {
		"submit": "login",
		"title": "Welcome back !",
		"account": "Email adress",
		"accountPlaceholder": "Enter your email",
		"password": "Password",
		"passwordPlaceholder": "Password",
		"remenber": "Remenber me",
		"forgotPwd": "Forgot password?",
		"toRegisterMsg": "Don't have an account?",
		"toRegister": "Sign up",
		"forgotTitle": "Enter your email address, and we will send you a reset link.",
		"register": "Register",
		"email": "Email",
		"emailPlaceholder": "Enter your email address",
		"name": "Name",
		"namePlaceholder": "Please enter your name"
	}
}